import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import './ExchangeLanding.scss';

import {
  getIsMobileParam,
  isCustomerWebViewEnabled,
  isEmbeddedInIFrame,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { BUCKET_ROLL } from '../../../redux/modules/modals/modals.module';
import { getProductTypes } from '../../../redux/modules/productTypes/productType.selectors';
import { constructExchangeEmail } from '../../../redux/modules/user/Communication/userCommunication.selectors';
import {
  getIsAddressAvailable,
  getIsNotForeignAddress,
  getHouseholdBalanceTierStatus,
} from '../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import {
  ADDRESS_INCOMPLETE,
  APP_FAILURE,
  collegeDisclaimerMap,
  COLLEGE_EXCHANGE_REDIRECT,
  DOB_FAILURE,
  EXCHANGE_TO_EXISTING_LOAD_FAILED,
  executingExchangeMessages,
  FOREIGN_ADDRESS,
  loadingExchangeAppMessages,
  NOT_RETAIL_CLIENT,
  TIMEOUT,
} from '../../../settings/settings';
import { scrollElementIntoFullView } from '../../../utils/dom-utils';
import { appendBasePath } from '../../../utils/nav.utils';
import { arrayToSentence, hasValue } from '../../../utils/utils';
import BalancesAsOfToolTip from '../../Shared/BalancesAsOfToolTip/BalancesAsOfToolTip';
import FullPageLoader from '../../Shared/FullPageLoader/FullPageLoader';
import Note from '../../Shared/Note/Note';
import StepsPageBackground from '../../Shared/StepsPageBackground/StepsPageBackground';
import TRP from '../../Shared/TRP/TRP';
import If from '../../Shared/If/If';
import ExchangeSteps from '../ExchangeSteps/ExchangeSteps';
import '../../Buy/BuyFlow/ExpandedFundList//MarketVolatilityNote.scss';
import { getIsRMDEligible } from '../../../redux/modules/RMD/RMDSetting.selectors';
import { getHasTaxableFunds } from 'src/redux/modules/funds/UserFunds/userFunds.selectors';
import { getApplicationStatus } from '../../../redux/modules/applicationData/applicationData.selectors';

export class ExchangeLanding extends Component {
  componentDidUpdate(prevProps) {
    this.resetScrollPositionOnError(prevProps);
    this.checkNeedPushConfirm(prevProps);
    this.checkBucketRoll(prevProps);
    if (
      prevProps.applicationData.isLoading !==
      this.props.applicationData.isLoading
    ) {
      scrollElementIntoFullView('navigation-font');
    }
  }
  checkBucketRoll(prevProps) {
    const { bucketRoll: prevBucketRoll } = prevProps;
    const {
      actions: { openModal },
      bucketRoll,
      hasRetirementFunds,
    } = this.props;
    if (
      bucketRoll.nextYearContributionAmountAvailable &&
      bucketRoll !== prevBucketRoll &&
      hasRetirementFunds
    ) {
      openModal(BUCKET_ROLL);
    }
  }

  resetScrollPositionOnError(prevProps) {
    const { exchangeTransaction, executeExchange } = this.props;
    if (
      (exchangeTransaction.exchangeToExistingLoadFailed &&
        prevProps.exchangeTransaction.exchangeToExistingLoadFailed !==
          exchangeTransaction.exchangeToExistingLoadFailed) ||
      (executeExchange.hasFailed &&
        prevProps.executeExchange.hasFailed !== executeExchange.hasFailed)
    ) {
      scrollElementIntoFullView('exchange-page-container');
    }
  }

  checkNeedPushConfirm(prevProps) {
    const {
      actions: { sendConfirmationEmail },
      executeExchange: { isLoaded, transactions },
      history,
    } = this.props;
    const {
      executeExchange: { isLoading: wasLoading },
    } = prevProps;

    if (wasLoading && isLoaded && hasValue(transactions)) {
      sendConfirmationEmail(constructExchangeEmail(transactions));
      history.push(appendBasePath('/exchange/confirm'));
    }
  }

  render() {
    const {
      isIFrame,
      isSalesforceRep,
      customerWebViewEnabled,
      applicationData,
      dateOfBirth,
      personalInfoFailed,
      executeExchange,
      exchangeTransaction,
      isAddressAvailable,
      isNotForeignAddress,
      isCorporateAccountType,
      IRALimit,
      personalInformation: { data: personalData },
      productTypes,
      isRMDEligible,
      hasTaxable,
    } = this.props;
    const hasMutualFund =
      productTypes && (productTypes.hasMutualFund || productTypes.hasAPP);
    const { hasAK529, hasNAT529 } = productTypes;
    const isLoaderVisible =
      applicationData.isLoading || executeExchange.isLoading;
    const { retailEnabled } = personalData;
    const message = applicationData.isLoading
      ? loadingExchangeAppMessages
      : executeExchange.isLoading
      ? executingExchangeMessages
      : '';
    const getError = () => {
      if (!personalInfoFailed && !dateOfBirth && !isCorporateAccountType) {
        return {
          type: DOB_FAILURE,
          hasError: true,
        };
      }
      if (!personalInfoFailed && !isNotForeignAddress) {
        return {
          type: FOREIGN_ADDRESS,
          hasError: true,
        };
      }
      if (executeExchange.hasFailed) {
        return {
          type: TIMEOUT,
          hasError: true,
        };
      }
      if (!retailEnabled && !isSalesforceRep) {
        return {
          type: NOT_RETAIL_CLIENT,
          hasError: true,
        };
      }
      if (exchangeTransaction.exchangeToExistingLoadFailed) {
        return {
          type: EXCHANGE_TO_EXISTING_LOAD_FAILED,
          hasError: true,
        };
      }
      if (!isAddressAvailable) {
        return {
          type: ADDRESS_INCOMPLETE,
          hasError: true,
        };
      }
      if (
        applicationData.hasFailed ||
        (IRALimit.hasFailed && !isCorporateAccountType)
      ) {
        return {
          type: APP_FAILURE,
          hasError: true,
        };
      }
      if (!hasMutualFund) {
        return {
          type: COLLEGE_EXCHANGE_REDIRECT,
          hasError: true,
        };
      }
      return {
        type: '',
        hasError: false,
      };
    };

    return (
      <div id="exchange-page-container">
        <FullPageLoader
          isVisible={isLoaderVisible}
          hasError={getError().hasError}
          errorType={getError().type}
          messages={message}
        />
        <If test={!(isIFrame || (!customerWebViewEnabled && isSalesforceRep))}>
          <StepsPageBackground />
        </If>
        <div className="container">
          <ExchangeSteps eligibleForRMD={isRMDEligible} />
          <BalancesAsOfToolTip />
          <hr />
          <div
            className={
              !customerWebViewEnabled && isSalesforceRep
                ? 'market-volatility-note-box'
                : ''
            }
          >
            <div
              className={
                !customerWebViewEnabled && isSalesforceRep
                  ? 'market-volatility-note'
                  : 'note-container'
              }
            >
              {hasTaxable && (
                <Note
                  className="excessive-trading-policy-note"
                  title={'Please Note:'}
                >
                  If you are redeeming covered shares using the Average Cost
                  method, and you proceed with this method, you will not be able
                  to revoke Average Cost for these remaining covered shares, and
                  the cost basis of other covered shares you currently hold in
                  this fund will be calculated using Average Cost.
                </Note>
              )}
              <Note
                className="excessive-trading-policy-note"
                title={
                  !customerWebViewEnabled && isSalesforceRep
                    ? 'Only for Redemptions and Exchanges in Excess of $5000 (Except Money Markets and Ultra Short Term Bond Fund):'
                    : 'Our Excessive Trading Policy:'
                }
              >
                <span>
                  As stated in the funds' prospectuses and subject to certain
                  exceptions,
                </span>
                each <TRP /> fund restricts a shareholder's purchases (including
                through exchanges) into a fund account for a period of 30
                calendar days after the shareholder has redeemed or exchanged
                out of that same fund account ("30-Day Purchase Block").
                Generally, transactions of $5,000 or less are not subject to the
                30-Day Purchase Block. Please see the fund's prospectus for more
                information. The calendar day after the date of redemption is
                considered Day 1 for purposes of computing the period before
                another purchase may be made. Automatic transactions (such as
                Automatic Asset Builder, automatic exchanges, and automatic
                withdrawals) generally are exempt from the policy. Checkwriting
                redemptions and transactions solely in money market funds are
                exempt from this policy.
              </Note>
              {(hasAK529 || hasNAT529) && (
                <Note className="MF-529-exchange-note">
                  **Contributions cannot be made to a 529 account that will
                  cause the aggregate balance of all accounts for that
                  beneficiary to exceed the plan maximum. It is acceptable for
                  earnings (but not contributions) to cause the total of the
                  account values to exceed the plan maximum. For more
                  information on the minimum and maximum amounts, please see the{' '}
                  {arrayToSentence(
                    [
                      hasNAT529 && collegeDisclaimerMap.national,
                      hasAK529 && collegeDisclaimerMap.alaska,
                    ]
                      .filter((v) => v)
                      .map(({ name, type, url }) => (
                        <a
                          className={`e2e-${type}-disclosure-link college-branded-link`}
                          href={url}
                          rel="noopener noreferrer"
                          key={type}
                          target="_blank"
                        >
                          {name}
                        </a>
                      ))
                  )}
                  .
                  <br />
                </Note>
              )}
            </div>
            <p style={{ margin: '10px 0' }}>2754810</p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { executeExchange, exchangeTransaction } = state;
  return {
    isIFrame: isEmbeddedInIFrame(state),
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    applicationData: getApplicationStatus(state),
    executeExchange,
    exchangeTransaction,
    productTypes: getProductTypes(state),
    isAddressAvailable: getIsAddressAvailable(state),
    isNotForeignAddress: getIsNotForeignAddress(state),
    householdBalanceTierStatus: getHouseholdBalanceTierStatus(state),
    isMobileParam: getIsMobileParam(state),
    isRMDEligible: getIsRMDEligible(state),
    hasTaxable: getHasTaxableFunds(state),
  };
};

export default compose(connect(mapStateToProps), withRouter)(ExchangeLanding);
